// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z7UY","type":"styles_type__LgpA4","choices":"styles_choices__33sUW"};